export interface DrawerContainerWidthConfig {
  defaultWidth: number;
  minWidth: number;
  maxWidth: number;
}

export enum DrawerState {
  Open = 'open',
  Close = 'close',
}

export enum DrawerWidth {
  Min = 300,
  Max = 900,
  Default = 500,
}
